import { useCallback, useEffect, useState } from 'react';
import client from '../api/client';

// Which raster periods actually exist on the server.
//
// Previously the map built a filename from the selected date and fetched it
// blindly; a missing month produced a 404 and a silently blank overlay. Knowing
// the index up front lets the UI say "no data for this month" instead.
export const useRasters = () => {
  const [types, setTypes] = useState({});
  const [state, setState] = useState({ loading: true, error: null });

  const load = useCallback(async () => {
    try {
      const { data } = await client.get('panel/rasters');
      setTypes(data.types || {});
      setState({ loading: false, error: null });
    } catch (error) {
      setTypes({});
      setState({ loading: false, error });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // `type` is the API name ("SPI" | "CU" | "SPI-3M"), `period` is "YYYY-MM".
  const hasPeriod = useCallback(
    (type, period) => (types[type] || []).some((f) => f.period === period),
    [types],
  );

  const periodsFor = useCallback((type) => types[type] || [], [types]);

  return { types, hasPeriod, periodsFor, reload: load, ...state };
};

export default useRasters;
